import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class IntervenientesService {
  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }

  getAllIntervenientes(
    pageIndex: number,
    contract_id: any,
    sortDirection?: string,
    sortProperty?: string,
    nomeEntidade?: string,
    tipoEntidade?: string,
  ) {

    const params = new HttpParams().set('page', pageIndex?.toString() || '0')
      .set('size', '10')
      .set('sortField', sortProperty || 'id')
      .set('sortDirection', sortDirection || 'asc')
      .set('razaoSocialEntidade', nomeEntidade || '')
      .set('nomeTipoEntidade', tipoEntidade || '')
    return this.http.get(`${this.baseUrl}/v1/contratos/${contract_id}/intervenientes`, { params })
  }
  addIntervenientes(formdata: any, contractId: any) {
    return this.http.post(`${this.baseUrl}/v1/contratos/${contractId}/intervenientes`, { ...formdata })
  }
  editIntervenientes(formdata: any, contractId: any, intervenerId: any) {
    return this.http.put(`${this.baseUrl}/v1/contratos/${contractId}/intervenientes/${intervenerId}`, { ...formdata })
  }
  deleteIntervenientes(contractId: any, intervenerId: any) {
    return this.http.delete(`${this.baseUrl}/v1/contratos/${contractId}/intervenientes/${intervenerId}`,)
  }
  AtivarIntervenientes(contractId: any, intervenerId: any, data: any) {
    return this.http.patch(`${this.baseUrl}/v1/contratos/${contractId}/intervenientes/${intervenerId}/ativar`, { ...data })
  }
  inativarIntervenientes(contractId: any, intervenerId: any, data: any) {
    return this.http.patch(`${this.baseUrl}/v1/contratos/${contractId}/intervenientes/${intervenerId}/inativar`, { ...data })
  }
  getHistoryInterveniente(contractId: string | null,  entitieId: string | null, pageIndex:number = 0){
    return this.http.get(this.baseUrl + `/v1/contratos/${contractId}/intervenientes/${entitieId}/historico?page=${pageIndex}&size=10&sortField=data&sortDirection=desc`);
  }
}
